// Кодировки, нужные подписи и заголовкам. Ручные, а не из зависимости: base64url без паддинга —
// три строки, а лишняя зависимость в ядре живёт годами.

/**
 * Байты, которыми ядро владеет само. Отдельный псевдоним нужен из-за типов TypeScript: обычный
 * `Uint8Array` может смотреть в разделяемую память, а WebCrypto и `fetch` принимают только обычную.
 */
export type Bytes = Uint8Array<ArrayBuffer>;

/** base64url без паддинга (RFC 4648 §5) — в таком виде едут nonce и подпись. */
export function toBase64Url(bytes: Bytes): string {
  let binary = "";
  for (const b of bytes) {
    binary += String.fromCharCode(b);
  }
  return btoa(binary).replaceAll("+", "-").replaceAll("/", "_").replaceAll("=", "");
}

/** Разбор base64url; паддинг необязателен. */
export function fromBase64Url(text: string): Bytes {
  const padded = text.replaceAll("-", "+").replaceAll("_", "/");
  const binary = atob(padded.padEnd(Math.ceil(padded.length / 4) * 4, "="));
  const out = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    out[i] = binary.charCodeAt(i);
  }
  return out;
}

/** Шестнадцатеричная строка → байты (для векторов и отладки). */
export function fromHex(hex: string): Bytes {
  if (hex.length % 2 !== 0) {
    throw new Error(`шестнадцатеричная строка нечётной длины: ${hex.length}`);
  }
  const out = new Uint8Array(hex.length / 2);
  for (let i = 0; i < out.length; i++) {
    out[i] = Number.parseInt(hex.slice(i * 2, i * 2 + 2), 16);
  }
  return out;
}

/** Байты → шестнадцатеричная строка. */
export function toHex(bytes: Bytes): string {
  let out = "";
  for (const b of bytes) {
    out += b.toString(16).padStart(2, "0");
  }
  return out;
}

/** Склейка байтовых кусков. */
export function concatBytes(...parts: readonly Bytes[]): Bytes {
  let total = 0;
  for (const p of parts) {
    total += p.length;
  }
  const out = new Uint8Array(total);
  let offset = 0;
  for (const p of parts) {
    out.set(p, offset);
    offset += p.length;
  }
  return out;
}
